/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as UpdatePasswordRouteImport } from './../routes/update-password'
import { Route as ResetPasswordRouteImport } from './../routes/reset-password'
import { Route as RegisterRouteImport } from './../routes/register'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as EmailChangeRouteImport } from './../routes/email-change'
import { Route as AuthenticatedRouteRouteImport } from './../routes/_authenticated/route'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as AuthenticatedProfileRouteImport } from './../routes/_authenticated/profile'
import { Route as AuthenticatedListsIndexRouteImport } from './../routes/_authenticated/lists/index'
import { Route as AuthenticatedListsNewRouteImport } from './../routes/_authenticated/lists/new'
import { Route as AuthenticatedListsListIdIndexRouteImport } from './../routes/_authenticated/lists/$listId/index'
import { Route as AuthenticatedListsListIdEditRouteImport } from './../routes/_authenticated/lists/$listId/edit'
import { Route as AuthenticatedListsListIdDeleteRouteImport } from './../routes/_authenticated/lists/$listId/delete'
import { Route as AuthenticatedListsListIdTasksNewRouteImport } from './../routes/_authenticated/lists/$listId/tasks/new'
import { Route as AuthenticatedListsListIdTasksCompletedRouteImport } from './../routes/_authenticated/lists/$listId/tasks/completed'
import { Route as AuthenticatedListsListIdTasksTaskIdEditRouteImport } from './../routes/_authenticated/lists/$listId/tasks/$taskId/edit'
import { Route as AuthenticatedListsListIdTasksTaskIdDeleteRouteImport } from './../routes/_authenticated/lists/$listId/tasks/$taskId/delete'

const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailChangeRoute = EmailChangeRouteImport.update({
  id: '/email-change',
  path: '/email-change',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedListsIndexRoute = AuthenticatedListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedListsNewRoute = AuthenticatedListsNewRouteImport.update({
  id: '/lists/new',
  path: '/lists/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedListsListIdIndexRoute =
  AuthenticatedListsListIdIndexRouteImport.update({
    id: '/lists/$listId/',
    path: '/lists/$listId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedListsListIdEditRoute =
  AuthenticatedListsListIdEditRouteImport.update({
    id: '/lists/$listId/edit',
    path: '/lists/$listId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedListsListIdDeleteRoute =
  AuthenticatedListsListIdDeleteRouteImport.update({
    id: '/lists/$listId/delete',
    path: '/lists/$listId/delete',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedListsListIdTasksNewRoute =
  AuthenticatedListsListIdTasksNewRouteImport.update({
    id: '/lists/$listId/tasks/new',
    path: '/lists/$listId/tasks/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedListsListIdTasksCompletedRoute =
  AuthenticatedListsListIdTasksCompletedRouteImport.update({
    id: '/lists/$listId/tasks/completed',
    path: '/lists/$listId/tasks/completed',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedListsListIdTasksTaskIdEditRoute =
  AuthenticatedListsListIdTasksTaskIdEditRouteImport.update({
    id: '/lists/$listId/tasks/$taskId/edit',
    path: '/lists/$listId/tasks/$taskId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedListsListIdTasksTaskIdDeleteRoute =
  AuthenticatedListsListIdTasksTaskIdDeleteRouteImport.update({
    id: '/lists/$listId/tasks/$taskId/delete',
    path: '/lists/$listId/tasks/$taskId/delete',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/email-change': typeof EmailChangeRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/update-password': typeof UpdatePasswordRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/lists/new': typeof AuthenticatedListsNewRoute
  '/lists/': typeof AuthenticatedListsIndexRoute
  '/lists/$listId/delete': typeof AuthenticatedListsListIdDeleteRoute
  '/lists/$listId/edit': typeof AuthenticatedListsListIdEditRoute
  '/lists/$listId/': typeof AuthenticatedListsListIdIndexRoute
  '/lists/$listId/tasks/completed': typeof AuthenticatedListsListIdTasksCompletedRoute
  '/lists/$listId/tasks/new': typeof AuthenticatedListsListIdTasksNewRoute
  '/lists/$listId/tasks/$taskId/delete': typeof AuthenticatedListsListIdTasksTaskIdDeleteRoute
  '/lists/$listId/tasks/$taskId/edit': typeof AuthenticatedListsListIdTasksTaskIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/email-change': typeof EmailChangeRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/update-password': typeof UpdatePasswordRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/lists/new': typeof AuthenticatedListsNewRoute
  '/lists': typeof AuthenticatedListsIndexRoute
  '/lists/$listId/delete': typeof AuthenticatedListsListIdDeleteRoute
  '/lists/$listId/edit': typeof AuthenticatedListsListIdEditRoute
  '/lists/$listId': typeof AuthenticatedListsListIdIndexRoute
  '/lists/$listId/tasks/completed': typeof AuthenticatedListsListIdTasksCompletedRoute
  '/lists/$listId/tasks/new': typeof AuthenticatedListsListIdTasksNewRoute
  '/lists/$listId/tasks/$taskId/delete': typeof AuthenticatedListsListIdTasksTaskIdDeleteRoute
  '/lists/$listId/tasks/$taskId/edit': typeof AuthenticatedListsListIdTasksTaskIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/email-change': typeof EmailChangeRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/update-password': typeof UpdatePasswordRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/lists/new': typeof AuthenticatedListsNewRoute
  '/_authenticated/lists/': typeof AuthenticatedListsIndexRoute
  '/_authenticated/lists/$listId/delete': typeof AuthenticatedListsListIdDeleteRoute
  '/_authenticated/lists/$listId/edit': typeof AuthenticatedListsListIdEditRoute
  '/_authenticated/lists/$listId/': typeof AuthenticatedListsListIdIndexRoute
  '/_authenticated/lists/$listId/tasks/completed': typeof AuthenticatedListsListIdTasksCompletedRoute
  '/_authenticated/lists/$listId/tasks/new': typeof AuthenticatedListsListIdTasksNewRoute
  '/_authenticated/lists/$listId/tasks/$taskId/delete': typeof AuthenticatedListsListIdTasksTaskIdDeleteRoute
  '/_authenticated/lists/$listId/tasks/$taskId/edit': typeof AuthenticatedListsListIdTasksTaskIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/email-change'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/update-password'
    | '/profile'
    | '/lists/new'
    | '/lists/'
    | '/lists/$listId/delete'
    | '/lists/$listId/edit'
    | '/lists/$listId/'
    | '/lists/$listId/tasks/completed'
    | '/lists/$listId/tasks/new'
    | '/lists/$listId/tasks/$taskId/delete'
    | '/lists/$listId/tasks/$taskId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/email-change'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/update-password'
    | '/profile'
    | '/lists/new'
    | '/lists'
    | '/lists/$listId/delete'
    | '/lists/$listId/edit'
    | '/lists/$listId'
    | '/lists/$listId/tasks/completed'
    | '/lists/$listId/tasks/new'
    | '/lists/$listId/tasks/$taskId/delete'
    | '/lists/$listId/tasks/$taskId/edit'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/email-change'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/update-password'
    | '/_authenticated/profile'
    | '/_authenticated/lists/new'
    | '/_authenticated/lists/'
    | '/_authenticated/lists/$listId/delete'
    | '/_authenticated/lists/$listId/edit'
    | '/_authenticated/lists/$listId/'
    | '/_authenticated/lists/$listId/tasks/completed'
    | '/_authenticated/lists/$listId/tasks/new'
    | '/_authenticated/lists/$listId/tasks/$taskId/delete'
    | '/_authenticated/lists/$listId/tasks/$taskId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  EmailChangeRoute: typeof EmailChangeRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  UpdatePasswordRoute: typeof UpdatePasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/update-password': {
      id: '/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof UpdatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-change': {
      id: '/email-change'
      path: '/email-change'
      fullPath: '/email-change'
      preLoaderRoute: typeof EmailChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/': {
      id: '/_authenticated/lists/'
      path: '/lists'
      fullPath: '/lists/'
      preLoaderRoute: typeof AuthenticatedListsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/new': {
      id: '/_authenticated/lists/new'
      path: '/lists/new'
      fullPath: '/lists/new'
      preLoaderRoute: typeof AuthenticatedListsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/': {
      id: '/_authenticated/lists/$listId/'
      path: '/lists/$listId'
      fullPath: '/lists/$listId/'
      preLoaderRoute: typeof AuthenticatedListsListIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/edit': {
      id: '/_authenticated/lists/$listId/edit'
      path: '/lists/$listId/edit'
      fullPath: '/lists/$listId/edit'
      preLoaderRoute: typeof AuthenticatedListsListIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/delete': {
      id: '/_authenticated/lists/$listId/delete'
      path: '/lists/$listId/delete'
      fullPath: '/lists/$listId/delete'
      preLoaderRoute: typeof AuthenticatedListsListIdDeleteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/tasks/new': {
      id: '/_authenticated/lists/$listId/tasks/new'
      path: '/lists/$listId/tasks/new'
      fullPath: '/lists/$listId/tasks/new'
      preLoaderRoute: typeof AuthenticatedListsListIdTasksNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/tasks/completed': {
      id: '/_authenticated/lists/$listId/tasks/completed'
      path: '/lists/$listId/tasks/completed'
      fullPath: '/lists/$listId/tasks/completed'
      preLoaderRoute: typeof AuthenticatedListsListIdTasksCompletedRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/tasks/$taskId/edit': {
      id: '/_authenticated/lists/$listId/tasks/$taskId/edit'
      path: '/lists/$listId/tasks/$taskId/edit'
      fullPath: '/lists/$listId/tasks/$taskId/edit'
      preLoaderRoute: typeof AuthenticatedListsListIdTasksTaskIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lists/$listId/tasks/$taskId/delete': {
      id: '/_authenticated/lists/$listId/tasks/$taskId/delete'
      path: '/lists/$listId/tasks/$taskId/delete'
      fullPath: '/lists/$listId/tasks/$taskId/delete'
      preLoaderRoute: typeof AuthenticatedListsListIdTasksTaskIdDeleteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedListsNewRoute: typeof AuthenticatedListsNewRoute
  AuthenticatedListsIndexRoute: typeof AuthenticatedListsIndexRoute
  AuthenticatedListsListIdDeleteRoute: typeof AuthenticatedListsListIdDeleteRoute
  AuthenticatedListsListIdEditRoute: typeof AuthenticatedListsListIdEditRoute
  AuthenticatedListsListIdIndexRoute: typeof AuthenticatedListsListIdIndexRoute
  AuthenticatedListsListIdTasksCompletedRoute: typeof AuthenticatedListsListIdTasksCompletedRoute
  AuthenticatedListsListIdTasksNewRoute: typeof AuthenticatedListsListIdTasksNewRoute
  AuthenticatedListsListIdTasksTaskIdDeleteRoute: typeof AuthenticatedListsListIdTasksTaskIdDeleteRoute
  AuthenticatedListsListIdTasksTaskIdEditRoute: typeof AuthenticatedListsListIdTasksTaskIdEditRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedListsNewRoute: AuthenticatedListsNewRoute,
  AuthenticatedListsIndexRoute: AuthenticatedListsIndexRoute,
  AuthenticatedListsListIdDeleteRoute: AuthenticatedListsListIdDeleteRoute,
  AuthenticatedListsListIdEditRoute: AuthenticatedListsListIdEditRoute,
  AuthenticatedListsListIdIndexRoute: AuthenticatedListsListIdIndexRoute,
  AuthenticatedListsListIdTasksCompletedRoute:
    AuthenticatedListsListIdTasksCompletedRoute,
  AuthenticatedListsListIdTasksNewRoute: AuthenticatedListsListIdTasksNewRoute,
  AuthenticatedListsListIdTasksTaskIdDeleteRoute:
    AuthenticatedListsListIdTasksTaskIdDeleteRoute,
  AuthenticatedListsListIdTasksTaskIdEditRoute:
    AuthenticatedListsListIdTasksTaskIdEditRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  EmailChangeRoute: EmailChangeRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  UpdatePasswordRoute: UpdatePasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
